import {
  IconBold,
  IconCode,
  IconColumnInsertLeft,
  IconColumnInsertRight,
  IconColumnRemove,
  IconH1,
  IconH2,
  IconH3,
  IconH4,
  IconH5,
  IconH6,
  IconHighlight,
  IconItalic,
  IconLetterH,
  IconList,
  IconListNumbers,
  IconLink,
  IconQuote,
  IconRowInsertBottom,
  IconRowInsertTop,
  IconRowRemove,
  IconStrikethrough,
  IconTable,
  IconUnderline,
} from '@tabler/icons-react';
import * as React from 'react';

import type { FormatType, FormatterConfig, ToolbarGroup } from './types';

type IconComponent = React.ComponentType<{ size?: number | string }>;

const makeIconRenderer =
  (Component: IconComponent) =>
  ({ size }: { size?: number | string } = {}) =>
    React.createElement(Component, { size });

export const FORMATTERS: Record<FormatType, FormatterConfig> = {
  bold: { aria: 'Жирный', renderIcon: makeIconRenderer(IconBold), shortcut: 'mod+B' },
  italic: { aria: 'Курсив', renderIcon: makeIconRenderer(IconItalic), shortcut: 'mod+I' },
  underline: { aria: 'Подчёркнутый', renderIcon: makeIconRenderer(IconUnderline), shortcut: 'mod+U' },
  strike: { aria: 'Зачёркнутый', renderIcon: makeIconRenderer(IconStrikethrough), shortcut: 'mod+Shift+X' },
  highlight: { aria: 'Выделение', renderIcon: makeIconRenderer(IconHighlight), shortcut: 'mod+Shift+H' },
  heading: { aria: 'Заголовки', renderIcon: makeIconRenderer(IconLetterH) },
  heading1: { aria: 'Заголовок H1', renderIcon: makeIconRenderer(IconH1), shortcut: 'mod+Alt+1' },
  heading2: { aria: 'Заголовок H2', renderIcon: makeIconRenderer(IconH2), shortcut: 'mod+Alt+2' },
  heading3: { aria: 'Заголовок H3', renderIcon: makeIconRenderer(IconH3), shortcut: 'mod+Alt+3' },
  heading4: { aria: 'Заголовок H4', renderIcon: makeIconRenderer(IconH4), shortcut: 'mod+Alt+4' },
  heading5: { aria: 'Заголовок H5', renderIcon: makeIconRenderer(IconH5), shortcut: 'mod+Alt+5' },
  heading6: { aria: 'Заголовок H6', renderIcon: makeIconRenderer(IconH6), shortcut: 'mod+Alt+6' },
  bulletList: { aria: 'Маркированный список', renderIcon: makeIconRenderer(IconList), shortcut: 'mod+Shift+8' },
  orderedList: { aria: 'Нумерованный список', renderIcon: makeIconRenderer(IconListNumbers), shortcut: 'mod+Shift+7' },
  blockquote: { aria: 'Цитата', renderIcon: makeIconRenderer(IconQuote) },
  codeBlock: { aria: 'Блок кода', renderIcon: makeIconRenderer(IconCode), shortcut: 'mod+Alt+C' },
  link: { aria: 'Ссылка', renderIcon: makeIconRenderer(IconLink), shortcut: 'mod+K' },
  table: { aria: 'Таблица', renderIcon: makeIconRenderer(IconTable) },
  tableAddRowBefore: { aria: 'Добавить строку выше', renderIcon: makeIconRenderer(IconRowInsertTop) },
  tableAddRowAfter: { aria: 'Добавить строку ниже', renderIcon: makeIconRenderer(IconRowInsertBottom) },
  tableDeleteRow: { aria: 'Удалить строку', renderIcon: makeIconRenderer(IconRowRemove) },
  tableAddColumnBefore: { aria: 'Добавить столбец слева', renderIcon: makeIconRenderer(IconColumnInsertLeft) },
  tableAddColumnAfter: { aria: 'Добавить столбец справа', renderIcon: makeIconRenderer(IconColumnInsertRight) },
  tableDeleteColumn: { aria: 'Удалить столбец', renderIcon: makeIconRenderer(IconColumnRemove) },
};

export const HEADING_FORMATTERS: FormatType[] = [
  'heading1',
  'heading2',
  'heading3',
  'heading4',
  'heading5',
  'heading6',
];
export const TABLE_FLOATING_FORMATTERS: FormatType[] = [
  'tableAddRowBefore',
  'tableAddRowAfter',
  'tableDeleteRow',
  'tableAddColumnBefore',
  'tableAddColumnAfter',
  'tableDeleteColumn',
];

export const TOOLBAR_GROUPS: ToolbarGroup[] = [
  { id: 'lists', title: 'Списки и цитаты', actions: ['bulletList', 'orderedList', 'blockquote', 'codeBlock'] },
  { id: 'insert', title: 'Вставка', actions: ['table'] },
];

export const DEFAULT_FLOATING_FORMATTERS: FormatType[] = [
  'heading',
  'bold',
  'italic',
  'underline',
  'strike',
  'highlight',
  'link',
];
